import { clsx } from 'clsx';
import { useState, useCallback } from 'react';
import { Button, Collapse } from '@material-ui/core';

import { useFormatMessage } from '../../../../../../intl/intl';
import hooks from './hooks';

import { CustomKeyValueBox } from '../../../../../common/custom-key-value-box';
import { CustomKeyValueListBox } from '../../../../../common/custom-key-value-list-box';

import useStyles from './styles';

import { Variants, FontWeight } from '../../../../../common/typography';

import type { BaseProps } from '../../../../../../interfaces';

export function SuccessSection({ classes = {} }: BaseProps) {
  const hasDetail = true;
  const [isDetailOpened, setIsDetailOpened] = useState(false);

  const _classes = useStyles({ hasDetail });

  const totalDetailsList = hooks.useTotalDetailList();

  const totalLabel = hooks.useTotalLabel();
  const totalValue = hooks.useTotalValue();

  const handleClickDetailButton = useCallback(() => {
    setIsDetailOpened(!isDetailOpened);
  }, [isDetailOpened]);

  return (
    <div className={clsx(_classes.root, classes?.root)}>
      {!!totalDetailsList && !!totalDetailsList.length && (
        <>
          <Collapse in={isDetailOpened} timeout='auto' unmountOnExit>
            <CustomKeyValueListBox
              classes={{
                root: clsx(
                  _classes.detailsListContainer,
                  classes?.detailsListContainer,
                ),
                label: clsx(
                  _classes.detailsListLabel,
                  classes?.detailsListLabel,
                ),
                value: clsx(_classes.detailListValue, classes?.detailListValue),
              }}
              list={totalDetailsList}
              labelPropertyName='text'
              valuePropertyName='value'
            />
          </Collapse>
          <Button
            classes={{
              root: clsx(_classes.detailButtonRoot, classes?.detailButtonRoot),
            }}
            fullWidth
            onClick={handleClickDetailButton}
          >
            <div className={clsx(_classes.detailHeader, classes?.detailHeader)}>
              <CustomKeyValueBox
                classes={{
                  label: clsx(_classes.totalLabel, classes?.totalLabel),
                  root: clsx(_classes.totalContainer, classes?.totalContainer),
                  value: clsx(_classes.totalValue, classes?.totalValue),
                }}
                label={totalLabel}
                labelFontWeight={FontWeight.Bold}
                value={totalValue}
                valueVariant={Variants.Subheadline}
                valueFontWeight={FontWeight.Bold}
                isDetailOpened={isDetailOpened}
                showIcon
              />
            </div>
          </Button>
        </>
      )}
    </div>
  );
}
